// The card issuer's decline from a failed card registration, as billing-verifone
// read it from the Verifone checkout (e.g. acquirer_response_code 138,
// "Insufficient Funds / Over Credit Limit1"). Verifone's redirect only carries
// its own error_code, which does not say why the card was declined.
const declineDetails = (err) => {
  const body = err && err.body
  if (!body || body.error !== 'checkout_failed') return {}

  const details = {
    decline_event: body.event,
    reason_code: body.reason_code,
    acquirer_response_code: body.acquirer_response_code,
    acquirer_response_message: body.acquirer_response_message,
  }
  return Object.fromEntries(Object.entries(details).filter(([, value]) => value !== undefined && value !== null))
}

export default declineDetails
